/**
 * Which submissions count as ENROLLMENT, on the frontend.
 *
 * MIRRORS backend/services/enrollmentSubmission.js - duplicated because CRA cannot import from
 * outside src/. Read that file for why this rule exists; the short version is that the migrant
 * questionnaire writes the same student link the enrollment packet does, and treating that link
 * as proof of enrollment told 90 families they were finished when they had submitted nothing.
 *
 * This reads submission_data._form_type, the discriminator stamped into a payload at submit time.
 * It is NOT form_instances.form_type - see utils/formApplicability.js for that one. The two
 * vocabularies overlap partially, which is worse than not overlapping at all; never compare them.
 */

export const NON_ENROLLMENT_SUBMISSION_TYPES = Object.freeze([
  'migrant-questionnaire',
  'school-lunch-application'
]);

/**
 * Exclusion, not inclusion: a submission with no `_form_type` at all is treated as enrollment,
 * because seven genuine pre-launch packets carry no type. A new kind that forgets to declare
 * itself shows up as enrollment - visible and wrong - rather than disappearing from a child's
 * record, which is the failure this rule exists to prevent.
 */
export function isEnrollmentSubmission(submission) {
  const t = submission && submission.submission_data && submission.submission_data._form_type;
  return !NON_ENROLLMENT_SUBMISSION_TYPES.includes(String(t || ''));
}

const enrollmentSubmission = { NON_ENROLLMENT_SUBMISSION_TYPES, isEnrollmentSubmission };
export default enrollmentSubmission;
